import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Paper,
    IconButton
} from '@material-ui/core';
import { obtenerReporteClientesRegistrohAction, obtenerReporteClientesRegistrohPaginaAction, obtenerReporteClientesRegistrohRegistrosAction } from '../../../ducks/reporteClientesDuck';
import { offLoadAction, onLoadAnction } from '../../../ducks/loadDuck';
import { FormatoFechaIso } from '../../../utils/FormatFecha';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
const columns = [
    { field: "0", headerName: "#" },
    { field: "1", headerName: "Cliente" },
    { field: "2", headerName: "Email Cliente" },
    { field: "3", headerName: "Teléfono" },
    { field: "4", headerName: "Agente" },
    { field: "5", headerName: "Email agente" },
    { field: "6", headerName: "Fecha registro" },
    { field: "7", headerName: "Coincidencias" },
];

const useObtenerReporteClientesRegistro = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }));
        dispatch(obtenerReporteClientesRegistrohAction()).then(() => {
            dispatch(offLoadAction());
        });
    }, [dispatch]);
};

const IntentoRegistro = () => {
    const { clientes, total, pagina, registroPagina } = useSelector((store) => store.reporteClientes)
    const rows = clientes
    const [expandedRows, setExpandedRows] = useState({});
    const dispatch = useDispatch();

    useObtenerReporteClientesRegistro()

    const handleChangePage = (event, newPage) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerReporteClientesRegistrohPaginaAction({ Pagina: newPage })).then(Response => {
            dispatch(offLoadAction())
        })
    }

    const handleChangeRowsPerPage = (event) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerReporteClientesRegistrohRegistrosAction({ Registros: +event.target.value })).then(Response => {
            dispatch(offLoadAction())
        })
    }

    const toggleRow = (id) => {
        setExpandedRows((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    return (
        <Paper>
            <TableContainer style={{maxHeight: "65vh"}}>
                <Table stickyHeader aria-label="sticky table" >
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell align='center' key={column.field}>{column.headerName}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, index) => (
                            <>
                                <TableRow key={row?.IdBitacoraCliente} hover>
                                    <TableCell align='center'>{index + 1}</TableCell>
                                    <TableCell align='center'>{row?.Nombre}</TableCell>
                                    <TableCell align='center'>{row?.EMail}</TableCell>
                                    <TableCell align='center'>{row?.Telefono}</TableCell>
                                    <TableCell align='center'>{`${row?.User?.Nombres} ${row?.User?.ApellidoPaterno} ${row?.User?.ApellidoMaterno}`}</TableCell>
                                    <TableCell align='center'>{row?.User?.Correo}</TableCell>
                                    <TableCell align='center'>{FormatoFechaIso({ date: row?.FechaRegistro, formato: "dd/MM/yyyy hh:mm aaaaa'm'" })}</TableCell>
                                    <TableCell align='center'>
                                        <IconButton
                                            aria-label="expand row"
                                            size="small"
                                            onClick={() => toggleRow(row?.IdBitacoraCliente)}
                                        >
                                            {expandedRows[row?.IdBitacoraCliente] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                        </IconButton>
                                    </TableCell>
                                </TableRow>

                                {expandedRows[row?.IdBitacoraCliente] && (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center">
                                            <Table size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="center">Cliente</TableCell>
                                                        <TableCell align="center">Email</TableCell>
                                                        <TableCell align="center">Telefono</TableCell>
                                                        <TableCell align="center">Agente asiganado</TableCell>
                                                        <TableCell align="center">Email agente asiganado</TableCell>
                                                        <TableCell align="center">Contrato firmado</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        row?.lCliente.map(cliente => {
                                                            return (
                                                                <TableRow key={cliente.IdCliente}>
                                                                    <TableCell align="center">{cliente?.Nombre}</TableCell>
                                                                    <TableCell align="center">{cliente?.EMail}</TableCell>
                                                                    <TableCell align="center">{cliente?.Telefono}</TableCell>
                                                                    <TableCell align="center">{cliente?.NombreAgente}</TableCell>
                                                                    <TableCell align="center">{cliente?.EMailAgente}</TableCell>
                                                                    <TableCell align="center">{
                                                                        (cliente?.CantCerradoGanado > 0) ?
                                                                            <CheckCircleIcon color='secondary' /> : "Sin cotratos firmados"
                                                                    }</TableCell>
                                                                </TableRow>
                                                            )
                                                        })
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={total}
                rowsPerPage={registroPagina}
                page={pagina}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
};

export default IntentoRegistro;
